export default __webpack_public_path__ + "static/youtube-232452477a3a6732aeaa837bf52ea6ca.png";